import styled, { css } from 'styled-components';

export const FiltersCountContainer = styled.div<{
  showOnRight?: boolean;
  withNumber: boolean;
  isMobile: boolean;
  isTablet: boolean;
}>`
  width: 8px;
  height: 8px;
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundLayer01};
  font-size: 11px;
  position: absolute;
  top: 0;
  left: calc(50% + 8px);
  border-radius: 9px;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.semibold};
  margin: 0 auto;

  ${({ isMobile, isTablet }) =>
    (isMobile || isTablet) &&
    css`
      width: 6px;
      height: 6px;
      left: 26px;
      top: 10px;
    `}

  ${({ withNumber }) =>
    withNumber &&
    css`
      width: 18px;
      height: 18px;
      justify-content: center;
      top: -8px;
      right: 0;
      left: unset;
    `}

  ${({ showOnRight }) =>
    showOnRight &&
    css`
      width: 6px;
      height: 6px;
      top: 7px;
      right: 0;
      @media (min-width: 768px) {
        right: 15%;
      }
    `}
`;
